
import {Component} from 'vue-property-decorator';
// mixins 中继承 Vue
import {mixins} from 'vue-class-component';
import Button from '@/components/Button.vue';
import tagHelper from '@/mixins/tagHelper.ts';
import HeaderBar from '@/components/HeaderBar.vue';

@Component({
  components: {HeaderBar, Button}
})

export default class Labels extends mixins(tagHelper) {
  // 读取Vuex中标签列表
  get tags() {
    return this.$store.state.tagStore.tagsList;
  }

  // lifeCircle hooks
  beforeCreate() {
    this.$store.commit('fetchTags');
  }
}
